import {buildAsyncActionsCreator, createAsyncActionExecutor} from '../asyncUtils';
import {ModelViewersActions} from './types';
import {requestModelViewers} from './api';

const modelViewersLoadActionsCreator = buildAsyncActionsCreator(ModelViewersActions.FETCH);
export const modelViewersLoad = createAsyncActionExecutor(modelViewersLoadActionsCreator, requestModelViewers);
